import { connect } from 'react-redux';
import Component from './component';
import setOpenNavigationDrawerAction from '../../actions/navigationdrawer/set';

const mapStateToProps = (state) => ({
  accounttype: state.accounttype.get('data'),
  session: state.session.get('data'),
  dashboard: state.dashboard.get('data'),
  dashboarderror: state.dashboard.get('error'),
  selectedplan: state.selected.get('planowner'),
  selectedplanowner: state.selected.get('planowner'),
  navigationdraweropen: state.navigationdrawer.get('open'),
  contact: state.contacts.get('set'),
  contactStatus: state.contacts.get('contactstatus'),
});

const mapDispatchToProps = (dispatch) => ({
  handleOpenNavigationDrawer: async (e, isOpen) => {
    if (e) e.preventDefault();
    await dispatch(await setOpenNavigationDrawerAction(isOpen));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
